/*
 * Vanilla JS equivalents of common utilities originally depending on jQuery.
 * This file mirrors src/js/functions.js but removes any jQuery usage.
 * Notes:
 * - jQuery-specific plugins like .affix(), .fadeIn(), .fadeOut(), matchHeight, etc., are omitted.
 * - Where appropriate, simple native approximations are provided.
 */

// Debounce helper (unchanged API)
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait || 200);
        if (callNow) {
            func.apply(context, args);
        }
    };
};

// Number.prototype.formatThousands (unchanged)
Number.prototype.formatThousands = function (c, d, t) {
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 0 : c,
        d = d === undefined ? "." : d,
        t = t === undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

// Simple deep merge to replace $.extend(true, ...)
function deepMerge(target) {
    target = target || {};
    for (var i = 1; i < arguments.length; i++) {
        var src = arguments[i];
        if (!src) continue;
        Object.keys(src).forEach(function (key) {
            var val = src[key];
            if (val && typeof val === 'object' && !Array.isArray(val)) {
                target[key] = deepMerge(target[key] || {}, val);
            } else {
                target[key] = val;
            }
        });
    }
    return target;
}

// Helper to get data-* as in $(el).data('x')
function dataGet(el, key) {
    if (!el || !key) return undefined;
    var dash = key.replace(/[A-Z]/g, function (m) { return '-' + m.toLowerCase(); });
    var attr = el.getAttribute('data-' + dash);
    if (attr != null) return attr;
    return (el.dataset ? el.dataset[key] : undefined);
}

// loadChart(chartDataName, type, targetId)
function loadChart(chartData, type, target) {
    if (target === undefined) {
        target = 'dynamic-loaded-chart';
    }
    var el = document.getElementById(String(chartData));
    bindChart(el, type, target, chartData);
}

// bindChart - vanilla version
function bindChart(chartObj, chartType, renderTo, id) {
    var $options = {};
    var $chartOptions = {};
    var chartData;

    if (!chartObj) return;

    var $chartID = chartObj.getAttribute('id');
    if (!chartConfig.hasOwnProperty($chartID)) {
        chartConfig[$chartID] = {};
    }

    var $dataChartType = chartType === undefined ? 'line' : chartType;

    // consider element data attributes
    var dt = dataGet(chartObj, 'chart-type');
    if (dt) {
        $dataChartType = dt;
    }

    // Resolve source data
    var srcData = dataGet(chartObj, 'source-data');
    if (srcData) {
        try { chartData = eval(srcData); } catch (e) { chartData = {}; }
    } else if (id !== undefined) {
        try { chartData = eval(id); } catch (e) { chartData = {}; }
    }

    // Minimal default options
    $chartOptions = {
        chart: {
            styledMode: true,
            type: $dataChartType,
            zoomType: 'xy',
            renderTo: renderTo === undefined ? $chartID : renderTo,
            backgroundColor: 'rgba(0, 0, 0, 0.0)'
        }
    };

    // Apply theme and config merges
    try {
        if (typeof Highcharts !== 'undefined') {
            if (typeof baseChartTheme !== 'undefined') {
                if (typeof chartTheme !== 'undefined' && chartTheme[$chartID] !== undefined) {
                    Highcharts.setOptions(deepMerge({}, baseChartTheme, chartTheme[$chartID]));
                } else {
                    Highcharts.setOptions(baseChartTheme);
                }
            }
        }
    } catch (e) { /* noop */ }

    deepMerge($chartOptions, chartConfig[$chartID] || {}, chartData || {});

    var chart;
    try {
        chart = new Highcharts.Chart(
            $chartOptions,
            function (chart) { _charts[chart.options.chart.renderTo] = chart; }
        );
    } catch (e) { /* noop */ }
    return chart;
}

function getStyleRuleValue(style, selector, sheet) {
    var sheets = typeof sheet !== 'undefined' ? [sheet] : document.styleSheets;
    for (var i = 0, l = sheets.length; i < l; i++) {
        var sheet = sheets[i];
        if (!sheet.cssRules) { continue; }
        for (var j = 0, k = sheet.cssRules.length; j < k; j++) {
            var rule = sheet.cssRules[j];
            if (rule.selectorText && rule.selectorText.split(',').indexOf(selector) !== -1) {
                return rule.style[style];
            }
        }
    }
    return null;
}

// Responsive helpers (reduced functionality vs jQuery version)
function onResize() {
    var isXS = (window.innerWidth || document.documentElement.clientWidth) <= 576;
    var navPills = document.querySelectorAll('.nav-pills');
    var container = document.getElementById('content-nav-container');
    if (isXS) {
        navPills.forEach ? navPills.forEach(function (el) { el.classList.add('nav-stacked'); }) : Array.prototype.forEach.call(navPills, function(el){ el.classList.add('nav-stacked');});
        if (container) {
            var menuW = (window.innerWidth || document.documentElement.clientWidth) || 0;
            container.style.width = (parseInt(menuW, 10) - 60) + 'px';
        }
    } else {
        navPills.forEach ? navPills.forEach(function (el) { el.classList.remove('nav-stacked'); }) : Array.prototype.forEach.call(navPills, function(el){ el.classList.remove('nav-stacked');});
        if (container) container.style.width = 'auto';
    }
}

var fixSideBar = (typeof fixSideBar !== 'undefined') ? fixSideBar : false;

function fixedSidebar() {
    // Note: Original relied on Bootstrap 3 Affix via jQuery; omitted here.
    // We keep minimal width synchronization when large screens.
    if (fixSideBar !== true) return;
    var contentNav = document.querySelector('.content-nav');
    var container = document.getElementById('content-nav-container');
    if (!contentNav || !container) return;
    var main = document.getElementById('main');
    if (main) {
        contentNav.style.width = container.parentElement ? container.parentElement.clientWidth + 'px' : contentNav.style.width;
        if ((window.innerWidth || 0) <= 767) {
            contentNav.style.width = (main.clientWidth || main.offsetWidth) + 'px';
        }
    }
}

function removeAffixedSidebar() {
    // No-op in vanilla; remove jQuery/Bootstrap Affix state if present via classes
    var container = document.getElementById('content-nav-container');
    if (!container) return;
    ['affix','affix-top','affix-bottom'].forEach(function(cls){ container.classList.remove(cls); });
}

function backToTopButton() {
    var header = document.querySelector('header');
    var toTop = document.getElementById('toTop');
    if (!header || !toTop) return;
    var navHeight = header.clientHeight || header.offsetHeight || 0;
    if ((window.pageYOffset || document.documentElement.scrollTop || 0) > navHeight) {
        toTop.style.display = '';
    } else {
        toTop.style.display = 'none';
    }
}

// Lightweight LazyLoad shim kept as in original
LazyLoad = function (e) {
    function t(t, n) {
        var s, c = e.createElement(t);
        for (s in n)
            n.hasOwnProperty(s) && c.setAttribute(s, n[s]);
        return c
    }
    function n(e) {
        var t, n, s = i[e];
        s && (t = s.callback, n = s.urls, n.shift(), u = 0, n.length || (t && t.call(s.context, s.obj), i[e] = null, f[e].length && c(e)))
    }
    function s() {
        var t = navigator.userAgent;
        o = {async: e.createElement("script").async === !0}, (o.webkit = /AppleWebKit\//.test(t)) || (o.ie = /MSIE|Trident/.test(t)) || (o.opera = /Opera/.test(t)) || (o.gecko = /Gecko\//.test(t)) || (o.unknown = !0)
    }
    function c(c, u, h, g, d) {
        var y, p, b, k, m, v, j = function () {
            n(c)
        }, w = "css" === c, T = [];
        if (o || s(), u) for (p = 0, b = u.length; p < b; ++p) T.push(w ? T = t("link", {href: u[p], rel: "stylesheet"}) : t("script", {src: u[p]})); else T.push(w ? T = t("link", {href: c, rel: "stylesheet"}) : t("script", {src: c}));
        for (m = 0, v = T.length; m < v; ++m) y = T[m], w ? (y.onload = j, y.onerror = j) : (y.onload = j, y.onerror = j), (h ? h : e.getElementsByTagName("head")[0]).appendChild(y);
        return {urls: u, obj: g, callback: d, context: h}
    }
    var o, i = {}, u = 0, f = {css: [], js: []}, h = e.styleSheets;
    return {css: function (e, t, n, s) {
            return c("css", e, t, n, s)
        }, js: function (e, t, n, s) {
            return c("js", e, t, n, s)
        }}
}(document);
